var hasOwnProperty=Object.prototype.hasOwnProperty;

var mapKeyValue=function mapKeyValue(obj,fn){
var result=[];
for(var key in obj){
if(hasOwnProperty.call(obj,key)){
result.push(fn(key,obj[key]));
}
}
return result;
};

module.exports=mapKeyValue;


//////////////////
// WEBPACK FOOTER
// /~/react-native-web/dist/modules/mapKeyValue/index.js
// module id = 199
// module chunks = 0